import { GrAttachment } from "react-icons/gr";

interface IFile {
  uid: string;
  name: string;
  url: string;
}

interface Props {
  files?: IFile[];
}

const FileList = ({ files = [] }: Props) => {
  if (files.length === 0) return <div>Không có tệp nào!</div>;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      {files.map((file) => (
        <a
          href={file.url}
          key={file.uid}
          target="_blank"
          rel="noreferrer"
          style={{ display: "flex", alignItems: "center", gap: 10 }}
        >
          <GrAttachment />
          {file.name}
        </a>
      ))}
    </div>
  );
};

export default FileList;
